export class ReportVariables {
    public static languageISOCode = 'languageISOCode';
    public static clubID = 'clubID';
}
